import DrawerRight from 'Components/DrawerRight'
import { WithLoader } from 'Components/WithLoader'
import { PRODUCTS_EDIT_DRAWER_TAB_PARAM_KEY } from 'Services/ProductManagement/constants'
import { TariffProductsEdit } from 'Services/ProductManagement/Features/Tariff/Components/TariffProductsEdit'
import {
  type Tariff,
  TariffProductsEditTabType,
  type TariffProductTabType
} from 'Services/ProductManagement/Features/Tariff/types'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Divider, Tab } from '@mui/material'
import type * as React from 'react'
import { useSearchParams } from 'react-router-dom'
import { t } from 'ttag'

interface TariffProductsEditDrawerProps {
  open: boolean
  onClose: () => void
  selectedTariff: Tariff | undefined
  isSingleTariffLoading: boolean
}

function TariffProductsEditDrawer({
  open,
  onClose,
  selectedTariff,
  isSingleTariffLoading
}: Readonly<TariffProductsEditDrawerProps>) {
  const [searchParams, setSearchParams] = useSearchParams()

  const productsEditDrawerTabFromParams =
    searchParams.get(PRODUCTS_EDIT_DRAWER_TAB_PARAM_KEY) ?? TariffProductsEditTabType.PRODUCTS

  const handleTabChange = (_event: React.SyntheticEvent, newValue: TariffProductTabType) => {
    searchParams.set(PRODUCTS_EDIT_DRAWER_TAB_PARAM_KEY, newValue)
    setSearchParams(searchParams)
  }

  const isLoading = isSingleTariffLoading

  return (
    <DrawerRight open={open} onClose={onClose}>
      <TabContext value={productsEditDrawerTabFromParams}>
        <TabList onChange={handleTabChange} aria-label={t`Tariff products tab list`}>
          <Tab label={t`Tariff products`} value={TariffProductsEditTabType.PRODUCTS} />
        </TabList>
        <Divider />
        <TabPanel sx={{ p: 0 }} value={TariffProductsEditTabType.PRODUCTS}>
          <WithLoader loading={isLoading}>
            {selectedTariff && (
              <TariffProductsEdit tariff={selectedTariff} handleCancel={onClose} />
            )}
          </WithLoader>
        </TabPanel>
      </TabContext>
    </DrawerRight>
  )
}

export default TariffProductsEditDrawer
